import { useState } from 'react';
import { PrivacyLinks, UserContext } from '../../../models/interface';
import ProductDescription, {
  ProductDescriptionProps,
} from '../product-description/ProductDescription';
import ProductDetails from '../product-details-fls/ProductDetailsFls';
import { ProductDetailsProps } from '../product-details/ProductDetails';
import ProductMedia, { ProductMediaProps } from '../product-media/ProductMedia';
import { ProductPresentationProps } from '../product-presentation/ProductPresentation';
import {
  ContentLeft,
  ContentRight,
  OuterWrapper,
  StickyDiv,
} from './ProductSeparated.style';
import ProductImageLiftedState, {
  ProductImageLiftedStateProps,
} from '../product-image/ProductImageLiftedState';

interface ProductSeparatedProps {
  productPresentationProps: ProductPresentationProps;
  productMediaProps: ProductMediaProps;
  productDetailsProps: ProductDetailsProps;
}

const ProductSeparated: React.FC<{
  data: ProductSeparatedProps;
  privacyPolicy: PrivacyLinks;
  userContext: UserContext;
  isPrerenderRequest: boolean;
}> = ({
  data,
  privacyPolicy,
  userContext,
  isPrerenderRequest,
}: {
  data: ProductSeparatedProps;
  privacyPolicy: PrivacyLinks;
  userContext: UserContext;
  isPrerenderRequest: boolean;
}) => {
  const [shouldBeSticky, setShouldBeSticky] = useState(true);

  const handleShouldBeSticky = (newValue: boolean) => {
    setShouldBeSticky(newValue);
  };
  const productImageProps: ProductImageLiftedStateProps = {
    prodName: data?.productPresentationProps?.prodName,
    prodImages: data?.productPresentationProps?.prodImages,
    categoriesCalculatedInfo:
      data?.productPresentationProps?.categoriesCalculatedInfo,
    shouldBeSticky: shouldBeSticky,
    handleShouldBeSticky: handleShouldBeSticky,
  };

  const productDescriptionProps: ProductDescriptionProps = {
    prodName: data?.productPresentationProps?.prodName,
    prodDesc: data?.productPresentationProps?.prodDesc,
    prodSrcs: data?.productPresentationProps?.prodSrcs,
    prodSrcsLabel: data?.productPresentationProps?.prodSrcsLabel,
    prodImages: data?.productPresentationProps?.prodImages,
    translations: data?.productPresentationProps?.translations,
    productCatalog: data?.productPresentationProps?.productCatalog,
    categoryName: data?.productPresentationProps?.categoryName,
    userCountry: userContext?.country,
  };

  return (
    <OuterWrapper>
      <ContentLeft>
        <StickyDiv shouldBeSticky={shouldBeSticky}>
          <ProductImageLiftedState data={productImageProps} />
        </StickyDiv>
      </ContentLeft>
      <ContentRight>
        <ProductDescription
          data={productDescriptionProps}
          privacyPolicy={privacyPolicy}
          isPrerenderRequest={isPrerenderRequest}
        />
        <ProductMedia data={data?.productMediaProps} />
        <ProductDetails
          data={data?.productDetailsProps}
          userContext={userContext}
          isPrerenderRequest={isPrerenderRequest}
        />
      </ContentRight>
    </OuterWrapper>
  );
};

export default ProductSeparated;
